import { Link } from "react-router-dom";
import Button from "components/Button";
import { JobInfoBox } from "components/hosted-scraping/job-list/JobInfoBox";

export const JobErrorMessage = ({ errorMessage, showCTAButtons, fixRelatedMessage, fixUrl }: { errorMessage: string; showCTAButtons: boolean; fixRelatedMessage?: string; fixUrl?: string }) => {
  return (
    <JobInfoBox bgColor="bg-error-50" borderColor="border-error-200" className="flex-col">
      <div className="flex flex-col gap-2">
        <p className="font-medium text-sm text-neutral-900">Error Details:</p>
        <p className="text-sm text-neutral-700">{errorMessage}{fixRelatedMessage}</p>
      </div>
      {showCTAButtons && fixUrl && (
        <Link to={fixUrl}>
          <Button
            text="FIX ISSUE"
            className="button button-secondary w-fit"
          />
        </Link>
      )}
    </JobInfoBox>
  );
}
